const colors = () => {
  return {
    1: ['Berry Red', '#B8255F'],
    2: ['Red', '#DB4035'],
    3: ['Orange', '#FF9933'],
    4: ['Yellow', '#FAD000'],
    5: ['Olive Green', '#AFB83B'],
    6: ['Lime Green', '#7ECC49'],
    7: ['Green', '#299438'],
    8: ['Mint Green', '#6ACCBC'],
    9: ['Teal', '#158FAD'],
    10: ['Sky Blue', '#14AAF5'],
    11: ['Light Blue', '#96C3EB'],
    12: ['Blue', '#4073FF'],
    13: ['Grape', '#884DFF'],
    14: ['Violet', '#AF38EB'],
    15: ['Lavender', '#EB96EB'],
    16: ['Magenta', '#E05194'],
    17: ['Salmon', '#FF8D85'],
    18: ['Charcoal', '#808080'],
    19: ['Grey', '#B8B8B8'],
    20: ['Taupe', '#CCAC93'],
  };
};

export default colors;
